module.exports = __webpack_public_path__ + "img/email-marketing-my.de4e223a.png";